import modular from "modujs";
import * as modules from "./modules";

/* Cache for communication between components */
window.prtx = {};

const app = new modular({
	modules: modules,
});

app.init(app);
